import React from "react";
import { motion } from "framer-motion";

const handMovement = {
  hidden: {
    rotate: 0,
  },
  visible: {
    rotate: 10,
    transition: {
      duration: 1,
      yoyo: Infinity,
    },
  },
};

const eyes = {
  hidden: {
    scale: 1,
  },
  visible: {
    scale: [0.2, 1],
    transition: {
      duration: 0.5,
      delay: 0.5,
      repeat: Infinity,
      repeatDelay: 2,
    },
  },
};

const eyeBrow = {
  hidden: {
    y: 0,
    rotate: 0,
  },
  visible: {
    rotate: [-15, 0],
    y: [1, 0],
    transition: {
      duration: 0.5,
      delay: 0.5,
      repeat: Infinity,
      repeatDelay: 2,
    },
  },
};

const eyeBrowGuy = {
  hidden: {
    y: 0,
  },
  visible: {
    y: [-3, 0, -3, 0],
    transition: {
      duration: 0.5,
      repeat: Infinity,
      repeatDelay: 5,
    },
  },
};

const stars = {
  hidden: {
    opacity: 1,
  },
  visible: {
    opacity: [0, 1, 0],
    transition: {
      duration: 2,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

const SvgComponent = (props) => (
  <svg id="groupSvg" viewBox="0 0 727 448" fill="none" {...props}>
    <g id="groupSvg">
      <g
        id="dottedLineSq"
        stroke="#F0C5D6"
        strokeWidth={1.1}
        className="dottedPaths"
      >
        <rect
          id="Rectangle_275"
          x={463.55}
          y={186.55}
          width={98.9}
          height={160.9}
          rx={36.45}
        />
        <rect
          id="Rectangle_276"
          x={163.55}
          y={140.55}
          width={98.9}
          height={160.9}
          rx={24.45}
        />
        <rect
          id="Rectangle_277"
          x={255.55}
          y={29.55}
          width={186.9}
          height={160.9}
          rx={49.45}
        />
      </g>
      <g id="laptopBottom">
        <path
          id="path26"
          d="M350.593 447.431c-148.184 0-268.31-15.548-268.31-34.729 0-1.62.857-3.215 2.516-4.776a374.346 374.346 0 013.19 4.744c.176.27 34.213.969 85.064 1.631l-6.352 3.726c-.998.079-1.771.668-1.772 1.381l-.004 7.786c-.001 2.729 3.185 4.942 7.116 4.943l362.296.179h.006c4.1 0 7.424-2.305 7.425-5.152l.005-7.569c0-.501-.382-.941-.954-1.187h.955l-.626-.374h.277l-6.262-3.741c39.331-.947 69.336-2.436 82.702-4.67.688 1.015 1.039 2.041 1.039 3.079 0 19.181-120.125 34.729-268.311 34.729z"
          fill="#7380C8"
        />
        <path
          id="path28"
          d="M173.053 414.301c-50.851-.662-84.888-1.361-85.065-1.631a374.346 374.346 0 00-3.189-4.744c3.42-3.22 10.253-6.299 20.004-9.175 9.156.218 45.141.439 93.672.636l-25.422 14.914zm362.11-.008l-23.866-14.257c47.305-.003 79.103-.094 79.254-.308.507-.723 1.007-1.453 1.497-2.19 13.924 3.708 22.899 7.784 25.817 12.085-13.366 2.234-43.371 3.723-82.702 4.67z"
          fill="#727EC7"
        />
        <path
          id="path30"
          d="M511.297 400.036l-8.573-5.121.006-10.825c38.03 3.395 68.963 8.028 89.318 13.448-.49.737-.99 1.466-1.497 2.19-.151.214-31.949.305-79.254.308zm-312.822-.649c-48.532-.197-84.516-.418-93.672-.636 21.087-6.216 55.837-11.479 99.329-15.154l-.005 12.385h.152l-5.804 3.405z"
          fill="#6F7DC7"
        />
      </g>
      <g id="extras">
        <g>
          <path
            id="path18"
            d="M668.829 341.23c-1.143 0-2.268-.157-3.362-.495-10.393-3.209-5.921-19.654-8.13-30.298-2.352-11.339 5.654-15.705 14.2-15.705 2.643 0 5.337.418 7.791 1.176 10.392 3.211 16.213 14.231 13.002 24.618-2.873 9.292-13.791 20.704-23.501 20.704z"
            fill="#F9FBFD"
          />
          <path
            id="path20"
            d="M649.685 77.324a18.348 18.348 0 00-12.135-4.562h-9.709a1.251 1.251 0 00-1.242-1.086h-8.01c-.634 0-1.159.473-1.24 1.086h-5.987c-9.76-8.002-17.292-19.862-14.204-29.85 4.544-14.699 27.832-8.374 42.905-11.497 1.932-.401 3.725-.589 5.378-.589 16.327 0 19.323 18.344 15.196 31.69a27.74 27.74 0 01-10.952 14.808z"
            fill="#F9FBFD"
          />
        </g>
        <motion.g
          id="stars"
          initial="hidden"
          animate="visible"
          variants={stars}
        >
          <path
            id="path32"
            d="M693.001 258.468a4.889 4.889 0 01-4.89-4.887 4.888 4.888 0 014.89-4.887c2.7 0 4.89 2.188 4.89 4.887a4.89 4.89 0 01-4.89 4.887z"
            fill="#8F8ECB"
          />
          <path
            id="path34"
            d="M324.621 9.774a4.888 4.888 0 110-9.774c2.7 0 4.89 2.187 4.89 4.887 0 2.7-2.19 4.887-4.89 4.887z"
            fill="#8F8ECB"
          />
          <path
            id="path36"
            d="M658.228 393.131a3.802 3.802 0 110-7.602 3.802 3.802 0 110 7.602z"
            fill="#F7B4C7"
          />
          <path
            id="path38"
            d="M68.168 89.052c-2.7 0-4.89-2.189-4.89-4.887a4.889 4.889 0 014.89-4.887c2.7 0 4.89 2.188 4.89 4.887a4.889 4.889 0 01-4.89 4.887z"
            fill="#F7B4C7"
          />
          <path
            id="path40"
            d="M31.22 271.5a3.802 3.802 0 113.804-3.802c0 2.1-1.702 3.802-3.803 3.802z"
            fill="#8F8ECB"
          />
          <path
            id="path42"
            d="M36.654 109.686a1.63 1.63 0 11-.001-3.258 1.63 1.63 0 01.001 3.258z"
            fill="#8F8ECB"
          />
          <path
            id="path44"
            d="M450.326 21.17a5.869 5.869 0 111.221-11.61 5.87 5.87 0 01-1.221 11.61z"
            fill="#F7B4C7"
          />
          <path
            id="path46"
            d="M5.879 303.529a5.869 5.869 0 111.22-11.608 5.868 5.868 0 01-1.22 11.608z"
            fill="#F7B4C7"
          />
          <path
            id="path48"
            d="M402.971 53.706a1.957 1.957 0 11-.005-3.916 1.957 1.957 0 01.005 3.916z"
            fill="#8F8ECB"
          />
        </motion.g>
      </g>
      <g id="chat2" fill="#F9FBFD">
        <path
          id="path50"
          d="M90.198 60.076a3.869 3.869 0 01-2.748-1.157l-8.819-8.814a1.742 1.742 0 00-1.236-.512h-10.85c-3 0-5.44-2.44-5.44-5.437V23.9a5.445 5.445 0 015.44-5.437h34.758c3 0 5.441 2.439 5.441 5.437v20.258a5.445 5.445 0 01-5.441 5.436h-5.41c-.963 0-1.748.785-1.748 1.748v4.806a3.86 3.86 0 01-2.42 3.62c-.502.208-1.018.31-1.527.31zM66.544 20.634a3.27 3.27 0 00-3.267 3.265v20.258a3.27 3.27 0 003.267 3.264h10.85c1.047 0 2.032.408 2.774 1.148l8.818 8.814c.342.342.77.52 1.216.52.228 0 .46-.047.69-.142a1.698 1.698 0 001.079-1.614v-4.805c0-2.162 1.76-3.921 3.922-3.921h5.409a3.27 3.27 0 003.268-3.264V23.899a3.27 3.27 0 00-3.268-3.265H66.545z"
        />
        <path
          id="path52"
          d="M73.6 37.467a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.175 2.175 0 00-2.172 2.172c0 1.198.974 2.172 2.173 2.172a2.175 2.175 0 002.173-2.172 2.175 2.175 0 00-2.173-2.172z"
        />
        <path
          id="path54"
          d="M83.924 38.01a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.175 2.175 0 00-2.173 2.172c0 1.198.975 2.172 2.173 2.172a2.175 2.175 0 002.173-2.172 2.175 2.175 0 00-2.173-2.172z"
        />
        <path
          id="path56"
          d="M93.704 38.01a3.263 3.263 0 01-3.26-3.258 3.263 3.263 0 013.26-3.258 3.263 3.263 0 013.26 3.258 3.263 3.263 0 01-3.26 3.258zm0-5.43a2.175 2.175 0 00-2.173 2.172c0 1.198.975 2.172 2.173 2.172a2.175 2.175 0 002.174-2.172 2.175 2.175 0 00-2.174-2.172z"
        />
      </g>
      <g id="chat1" fill="#fff">
        <path
          id="path58"
          d="M572.594 337.177a2.413 2.413 0 00-2.411 2.41v14.951a2.413 2.413 0 002.411 2.411h3.992a2.897 2.897 0 012.895 2.893v3.546c0 .54.298.986.797 1.192a1.253 1.253 0 001.407-.28l6.508-6.504a2.883 2.883 0 012.047-.847h8.008a2.413 2.413 0 002.411-2.411v-14.951a2.413 2.413 0 00-2.411-2.41h-25.654zm7.07 28.884a2.849 2.849 0 01-1.787-2.673v-3.546c0-.712-.58-1.291-1.291-1.291h-3.992a4.019 4.019 0 01-4.016-4.013v-14.951a4.02 4.02 0 014.016-4.014h25.654a4.02 4.02 0 014.016 4.014v14.951a4.019 4.019 0 01-4.016 4.013h-8.008c-.345 0-.669.134-.912.379l-6.51 6.504a2.852 2.852 0 01-3.154.627z"
        />
        <path
          id="path60"
          d="M591.437 347.196a1.605 1.605 0 003.208 0 1.605 1.605 0 00-3.208 0zm-.802 0a2.408 2.408 0 012.406-2.405 2.41 2.41 0 012.407 2.405 2.407 2.407 0 01-4.813 0z"
        />
        <path
          id="path62"
          d="M583.816 347.596a1.605 1.605 0 003.21 0c0-.884-.72-1.601-1.605-1.601s-1.605.717-1.605 1.601zm-.801 0a2.409 2.409 0 012.406-2.404 2.409 2.409 0 012.406 2.404 2.409 2.409 0 01-2.406 2.406 2.409 2.409 0 01-2.406-2.406z"
        />
        <path
          id="path64"
          d="M576.598 347.596a1.605 1.605 0 003.208 0 1.603 1.603 0 00-3.208 0zm-.802 0a2.409 2.409 0 012.406-2.404 2.409 2.409 0 012.406 2.404 2.409 2.409 0 01-2.406 2.406 2.409 2.409 0 01-2.406-2.406z"
        />
      </g>
      <g id="camera2" fill="#fff">
        <path
          id="path66"
          d="M111.386 279.522a3.015 3.015 0 00-3.012 3.01v22.4a3.015 3.015 0 003.012 3.01h30.534a3.015 3.015 0 003.012-3.01v-22.4a3.015 3.015 0 00-3.012-3.01h-30.534zm30.534 29.506h-30.534a4.102 4.102 0 01-4.099-4.096v-22.4a4.102 4.102 0 014.099-4.096h30.534a4.101 4.101 0 014.098 4.096v22.4a4.101 4.101 0 01-4.098 4.096z"
        />
        <path
          id="path68"
          d="M145.935 299.563h.001-.001zm.084.022l10.027 2.671-.042-17.038-9.985 2.661v11.706zm10.123 2.698h.011-.011zm-.026 1.083l-.256-.034-10.202-2.719a.977.977 0 01-.726-.945v-11.873c0-.441.298-.83.725-.944l10.203-2.719a.977.977 0 011.231.944v17.311a.97.97 0 01-.384.776.974.974 0 01-.591.203z"
        />
        <path
          id="path70"
          d="M120.01 279.272a.542.542 0 01-.543-.543v-2.343h-6.295v2.343a.543.543 0 11-1.087 0v-2.452c0-.539.438-.977.977-.977h6.514c.539 0 .978.438.978.977v2.452a.543.543 0 01-.544.543z"
        />
        <path
          id="path72"
          d="M128.498 279.272a.542.542 0 01-.543-.543v-1.91h-5.187v1.91a.542.542 0 11-1.086 0v-2.084c0-.503.408-.912.911-.912h5.536c.503 0 .913.409.913.912v2.084a.543.543 0 01-.544.543z"
        />
        <path
          id="path74"
          d="M125.915 284.87c-4.789 0-8.683 3.893-8.683 8.678 0 4.784 3.894 8.678 8.683 8.678 4.788 0 8.683-3.894 8.683-8.678 0-4.785-3.895-8.678-8.683-8.678zm0 18.442c-5.388 0-9.77-4.38-9.77-9.764 0-5.384 4.382-9.764 9.77-9.764 5.387 0 9.769 4.38 9.769 9.764 0 5.384-4.382 9.764-9.769 9.764z"
        />
        <path
          id="path76"
          d="M124.612 289.851v7.392l4.837-3.696-4.837-3.696zm-.485 7.763l-.002.002.002-.002zm.184 1.026a.766.766 0 01-.347-.082.777.777 0 01-.438-.702v-8.617c0-.3.167-.568.436-.702a.781.781 0 01.824.08l5.638 4.308a.777.777 0 01.307.622.781.781 0 01-.307.624l-5.637 4.307a.789.789 0 01-.476.162z"
        />
        <path
          id="path78"
          d="M139.201 283.025c-.921 0-1.67.751-1.67 1.671a1.671 1.671 0 003.341 0c0-.92-.75-1.671-1.671-1.671zm0 4.426a2.758 2.758 0 01-2.757-2.755 2.76 2.76 0 012.757-2.757 2.76 2.76 0 012.758 2.757 2.759 2.759 0 01-2.758 2.755z"
        />
        <path
          id="path80"
          d="M152.487 297.779a.542.542 0 01-.543-.543v-10.328a.544.544 0 011.087 0v10.328c0 .3-.244.543-.544.543z"
        />
      </g>
      <g id="camera1" fill="#F8FBFD">
        <path
          id="path82"
          d="M710.359 115.387h-33.906a4.102 4.102 0 01-4.099-4.096V86.247a4.102 4.102 0 014.099-4.097h1.129v.272a.542.542 0 101.087 0l-.008-.272h6.963v.272a.543.543 0 001.087 0v-.272h1.327v.272a.542.542 0 101.087 0v-.272h5.749v.272a.542.542 0 101.087 0v-.272h14.398a4.102 4.102 0 014.099 4.097v4.983l-.331.088a1.018 1.018 0 00-.756.982v12.937c0 .461.311.864.754.982l.333.088v4.984a4.102 4.102 0 01-4.099 4.096zm-33.906-32.15a3.015 3.015 0 00-3.012 3.01v25.044a3.015 3.015 0 003.012 3.01h33.906a3.015 3.015 0 003.012-3.01V86.247c0-1.66-1.351-3.01-3.012-3.01h-33.906zm38.005 22l-.052-12.869.052-.014v12.883z"
        />
        <path
          id="path84"
          d="M725.507 109.217l-.264-.035-10.785-2.875-.333-.088a1.017 1.017 0 01-.754-.982V92.3c0-.46.311-.863.755-.982l.332-.088 10.785-2.874a1 1 0 01.881.176c.253.194.398.487.398.805V108.2c0 .318-.145.613-.398.806a1.008 1.008 0 01-.617.211zm.016-1.084h.01-.01zm-11.065-2.896l11.005 2.881-.028-18.69-10.977 2.926-.052.014.052 12.869z"
        />
        <path
          id="path86"
          d="M686.168 82.965a.543.543 0 01-.544-.543V79.75l-7.026.07.063 2.33.008.27a.544.544 0 01-1.087 0v-2.67c0-.56.455-1.016 1.016-1.016h7.096c.561 0 1.017.456 1.017 1.016v2.67c0 .3-.243.544-.543.544z"
        />
        <path
          id="path88"
          d="M695.417 82.965a.542.542 0 01-.543-.543v-2.13h-5.749v2.13a.544.544 0 01-1.087 0V80.15c0-.52.424-.944.945-.944h6.031c.522 0 .947.423.947.945v2.27c0 .3-.244.544-.544.544z"
        />
        <path
          id="path90"
          d="M692.602 109.158c-5.843 0-10.596-4.75-10.596-10.59s4.753-10.59 10.596-10.59 10.596 4.75 10.596 10.59-4.753 10.59-10.596 10.59zm0-20.094c-5.243 0-9.51 4.263-9.51 9.504 0 5.24 4.267 9.504 9.51 9.504 5.243 0 9.509-4.264 9.509-9.504 0-5.24-4.266-9.504-9.509-9.504z"
        />
        <path
          id="path92"
          d="M690.853 104.068a.808.808 0 01-.806-.806v-9.388a.8.8 0 01.806-.805c.173 0 .346.056.491.166l6.14 4.694a.802.802 0 01-.001 1.28l-6.139 4.693a.817.817 0 01-.491.166zm.281-9.626v8.252l5.398-4.126-5.398-4.126zm5.69 4.349l.002.001-.002-.001z"
        />
        <path
          id="path94"
          d="M707.079 91.877a2.96 2.96 0 01-2.957-2.955 2.959 2.959 0 012.957-2.953 2.957 2.957 0 012.955 2.953 2.958 2.958 0 01-2.955 2.955zm0-4.822a1.872 1.872 0 00-1.871 1.867c0 1.031.839 1.87 1.871 1.87 1.03 0 1.869-.839 1.869-1.87 0-1.03-.839-1.867-1.869-1.867z"
        />
        <path
          id="path96"
          d="M721.554 103.129a.542.542 0 01-.543-.543V91.334a.542.542 0 111.086 0v11.252a.542.542 0 01-.543.543z"
        />
      </g>
      <g id="userIcon4">
        <path
          id="path98"
          d="M558.517 267.41c0 11.256-9.129 20.38-20.391 20.38-11.263 0-20.393-9.124-20.393-20.38 0-11.256 9.13-20.379 20.393-20.379 11.262 0 20.391 9.123 20.391 20.379z"
          fill="#F0F5FA"
        />
        <path
          id="path100"
          d="M545.569 263.365a7.441 7.441 0 01-7.443 7.441 7.443 7.443 0 01-7.446-7.441 7.443 7.443 0 017.446-7.44 7.442 7.442 0 017.443 7.44z"
          fill="#0B1726"
        />
        <path
          id="path102"
          d="M548.167 278.764c0 .178-20.084.17-20.084 0 0-5.542 4.497-10.035 10.043-10.035 5.545 0 10.041 4.493 10.041 10.035z"
          fill="#0B1726"
        />
      </g>
      <g id="3lines2" fill="#E0EEFF">
        <path id="path104" d="M625.282 258.805h-55.324v-8.796h55.324v8.796z" />
        <path id="path106" d="M638.049 271.275h-68.091v-5.671h68.091v5.671z" />
        <path id="path108" d="M638.049 284.034h-68.091v-5.671h68.091v5.671z" />
      </g>
      <g id="userIcon3">
        <path
          id="path110"
          d="M150.644 352.118c0 11.256 9.131 20.38 20.393 20.38s20.392-9.124 20.392-20.38c0-11.256-9.13-20.379-20.392-20.379-11.262 0-20.393 9.123-20.393 20.379z"
          fill="#fff"
        />
        <path
          id="path112"
          d="M163.592 348.074a7.442 7.442 0 007.445 7.44 7.442 7.442 0 007.445-7.44 7.443 7.443 0 00-7.445-7.441 7.443 7.443 0 00-7.445 7.441z"
          fill="#0B1726"
        />
        <path
          id="path114"
          d="M160.995 363.472c0 .178 20.084.17 20.084 0 0-5.542-4.496-10.035-10.042-10.035-5.546 0-10.042 4.493-10.042 10.035z"
          fill="#0B1726"
        />
      </g>
      <g id="3Lines" fill="#fff">
        <path id="path116" d="M88.226 343.513h55.326v-8.796H88.226v8.796z" />
        <path id="path118" d="M75.459 355.982h68.093v-5.671H75.459v5.671z" />
        <path id="path120" d="M75.459 368.742h68.093v-5.671H75.459v5.671z" />
      </g>
      <g id="guyAndGirlPhone">
        <path
          id="path122"
          d="M372.191 210.076V91.159c0-10.16 8.241-18.397 18.409-18.397h246.95c10.166 0 18.409 8.236 18.409 18.397v118.917c0 10.16-8.243 18.397-18.409 18.397H390.6c-10.168 0-18.409-8.237-18.409-18.397z"
          fill="#3C419F"
        />
        <path
          id="path124"
          d="M372.191 210.076V91.159c0-10.16 8.241-18.397 18.409-18.397h246.95c10.166 0 18.409 8.236 18.409 18.397v118.917c0 10.16-8.243 18.397-18.409 18.397H390.6c-10.168 0-18.409-8.237-18.409-18.397z"
          fill="#3C419F"
        />
        <path
          id="path126"
          d="M633.978 223.557H502.809l.001-3.366h132.752c6.871 0 12.441-5.567 12.441-12.434V93.478c0-6.867-5.57-12.434-12.441-12.434h-77.949l-.258-4.898-.004-.07h76.627c9.87 0 17.87 7.801 17.87 17.425v112.632c0 9.623-8 17.424-17.87 17.424zm-255.156-33.494l-2.441-.002v-96.56c0-9.624 8.001-17.425 17.87-17.425h107.283a20.34 20.34 0 00-.066 3.01l.103 1.958H391.262c-6.87 0-12.44 5.567-12.44 12.434v96.585z"
          fill="#4045A2"
        />
        <path
          id="path128"
          d="M378.822 207.757V93.478c0-6.867 5.57-12.434 12.44-12.434h244.3c6.871 0 12.441 5.567 12.441 12.434v114.279c0 6.867-5.57 12.434-12.441 12.434h-244.3c-6.87 0-12.44-5.567-12.44-12.434z"
          fill="#fff"
        />
        <path
          id="path130"
          d="M640.046 218.866c1.606 0 3.315-.664 4.435-2.451a12.382 12.382 0 003.522-8.658V93.478c0-4.783-2.707-8.929-6.67-11.01a9.305 9.305 0 00-1.287-.098v136.496z"
          fill="#6C92D3"
        />
        <path
          id="path132"
          d="M628.344 212.856H502.815l.007-16.674a6.049 6.049 0 00-2.87-5.155c.536-5.4-.381-11.026-2.577-15.642-1.998-4.199-4.913-8.865-3.029-13.441.59-1.433 1.596-2.624 2.409-3.931 4.118-6.618 2.808-13.928 1.075-20.994-.754-3.072-2.219-5.891-3.331-8.871h15.14c2.671 2.396 5.896 4.362 9.02 5.77l.042.383 1.258 20.754c.453 7.457 6.636 13.275 14.112 13.275 8.118 0 14.567-6.815 14.117-14.913l-1.24-22.319a51.175 51.175 0 003.961-2.95h77.435v84.708zm-231.001-22.784l-8.023-.005V89.052h57.787-57.787v39.096h18.056a33.28 33.28 0 00-.179 1.637c-.394 4.631.175 9.269-.144 13.9-.642 9.365-6.897 15.167-11.555 22.693-2.789 4.505-4.772 9.916-3.618 15.062.779 3.476 2.823 6.294 5.463 8.632z"
          fill="#F4F7FC"
        />
        <path
          id="path134"
          d="M628.344 128.148h-77.435c4.666-3.855 8.722-8.805 8.449-13.994l-.231-4.396 1.17-.062c4.982-.262 8.774-5.177 8.468-10.979-.246-4.668-3.071-8.488-6.761-9.665h66.34v39.096zm-118.705 0h-15.14c-.074-.2-.147-.401-.218-.603-1.258-3.572-2.298-7.221-3.463-10.825-2.053-6.365-4.583-12.75-9.023-17.677-4.138-4.59-9.751-7.657-15.676-9.306a40.214 40.214 0 00-2.872-.685h38.746l.14 2.665c-4.75.535-8.299 5.31-8.003 10.927.297 5.618 4.328 9.994 9.107 10.027l.234 4.424c.222 4.201 2.739 7.98 6.168 11.053zm-102.263 0H389.32V89.052h57.787a41.783 41.783 0 00-3.591.876c-7.467 2.181-13.995 7.106-19.986 12.009-6.167 5.05-11.615 11.441-14.395 19.051a34.105 34.105 0 00-1.759 7.16z"
          fill="#E5EEF9"
        />
        <path
          id="path136"
          d="M627.841 72.762h-10.492a1.252 1.252 0 011.24-1.086h8.01c.637 0 1.161.474 1.242 1.086z"
          fill="#606DBE"
        />
        <path
          id="path138"
          d="M626.599 74.178h-8.01a1.252 1.252 0 01-1.24-1.416h10.492a1.252 1.252 0 01-1.242 1.416z"
          fill="#4C5AB2"
        />
        <path
          id="path140"
          d="M603.069 230.232h-18.523a1.252 1.252 0 01-1.144-1.759h20.812a1.25 1.25 0 01-1.145 1.759z"
          fill="#5F6CBD"
        />
        <path
          id="path142"
          d="M604.214 228.473h-20.812a1.25 1.25 0 011.144-.743h18.523c.511 0 .95.305 1.145.743z"
          fill="#4C5AB2"
        />
        <path
          id="path144"
          d="M604.311 72.762h-21.006a1.251 1.251 0 011.241-1.086h18.523c.636 0 1.161.474 1.242 1.086z"
          fill="#616EBE"
        />
        <path
          id="path146"
          d="M603.069 74.178h-18.523a1.252 1.252 0 01-1.241-1.416h21.006a1.25 1.25 0 01-1.242 1.416z"
          fill="#4C5AB2"
        />
        <path
          id="path148"
          d="M579.278 72.762h-6.99a176.437 176.437 0 00-3.777-1.086h9.527c.635 0 1.16.474 1.24 1.086z"
          fill="#616EBE"
        />
        <path
          id="path150"
          d="M572.288 72.762h-7.751a97.962 97.962 0 00-1.589-1.086h5.563c1.266.349 2.522.71 3.777 1.086z"
          fill="#606DBE"
        />
        <path
          id="path152"
          d="M564.537 72.762h-6.263a1.25 1.25 0 011.24-1.086h3.435c.532.356 1.063.72 1.588 1.086z"
          fill="#5F6CBD"
        />
        <path
          id="path154"
          d="M578.038 74.178h-18.524a1.25 1.25 0 01-1.24-1.416h21.004a1.251 1.251 0 01-1.24 1.416z"
          fill="#4C5AB2"
        />
      </g>
      <g id="guyAndGirl">
        <g id="g158">
          <path
            id="path166"
            d="M610.597 147.432c-6.438-3.059-14.132-11.122-14.098-11.116l-5.375-5.741c-.929-.992-1.115-2.548-.283-3.622a2.724 2.724 0 014.147-.205s3.082 3.301 5.107 5.474c.842.905 2.393.293 2.343-.942-.072-1.802-.905-3.556-1.747-4.886l-12.041-15.699a2.72 2.72 0 01.508-3.81c1.883 0 4.358 1.223 5.503 2.718l7.04 9.201a1.3 1.3 0 001.592.383l.381-.181c.644-.308.938-1.06.677-1.723l-6.344-16.004c-.501-1.263-.104-2.78 1.066-3.473a2.722 2.722 0 013.933 1.328l6.12 15.444c.337.847 1.354 1.427 2.228 1.167a2.019 2.019 0 001.391-2.374l-3.276-14.599c-.299-1.327.331-2.762 1.595-3.265a2.72 2.72 0 013.676 1.924l3.405 15.171a4.791 4.791 0 001.559 2.589c.921.788 2.349.127 2.345-1.086l-.029-6.998c-.007-1.422 1.011-2.721 2.426-2.869a2.72 2.72 0 013.011 2.69l.396 15.262c.877 9.292.347 20.732.347 20.732v77.497h-12.283c-14.5 0-4.5-.5-14.5 0l9.18-72.987z"
            fill="#AF6D80"
          />
          <path
            id="path164"
            d="M569.09 150.508a142.703 142.703 0 00-4.345-1.013c-4.572-1.317-9.865-2.183-15.554-2.469l-.008-.009c-.209-.008-.251-.009-.139.001a81.343 81.343 0 00-4.304-.098l-4.207.017-5.776.024-5.776-.024-4.208-.017c-1.456-.007-2.89.03-4.303.098.111-.01.07-.009-.139-.001l-.007.009c-5.69.286-10.983 1.152-15.556 2.469a142.01 142.01 0 00-4.345 1.013c-23.187 5.779-39.986 26.011-42.336 49.997-.223.419-.448.831-.67 1.257l.528.297a58.961 58.961 0 00-.15 4.861l.143 13.59h153.637l.144-13.59c.281-26.729-17.399-50.123-42.629-56.412z"
            fill="#F17B99"
          />
          <path
            id="path168"
            d="M615.073 135.226l.076-.041a.674.674 0 00.22-.928c-1.677-2.711-3.779-4.299-6.245-4.72-4.12-.705-7.699 2.133-7.851 2.253a.672.672 0 00-.102.947.676.676 0 00.949.103c.031-.025 3.269-2.577 6.786-1.972 2.063.355 3.851 1.735 5.315 4.099.18.291.547.398.852.259z"
            fill="#322E44"
          />
          <path
            id="path170"
            d="M488.449 59.836c-.284-5.375 1.963-10.293 5.694-13.617a13.879 13.879 0 01-1.066-4.627c-.405-7.692 5.506-14.255 13.202-14.66a13.9 13.9 0 016.028 1.037c2.052-5.295 7.05-9.174 13.092-9.492 6.039-.318 11.417 3.016 14.016 8.065a13.885 13.885 0 015.885-1.663c7.696-.405 14.264 5.502 14.669 13.193.049.916 0 1.813-.123 2.689 5.8 2.472 10.006 8.058 10.359 14.773.466 8.834-5.886 16.448-14.46 17.746.394 9.203-50.088 11.87-50.672 2.685-8.832-.204-16.153-7.167-16.624-16.129z"
            fill="#322E44"
          />
          <path
            id="path172"
            d="M568.765 98.717c-.306-5.801-4.593-10.292-9.575-10.03l-1.172.062-.663-12.603a20.424 20.424 0 00-1.924-7.641 17.86 17.86 0 01-3.288.493c-6.82.358-12.936-3.172-16.214-8.647a18.907 18.907 0 01-9.046 2.85 18.902 18.902 0 01-9.295-1.885c-2.67 5.757-8.338 9.893-15.107 10.29a20.405 20.405 0 00-1.013 7.48l.665 12.63c-4.75.536-8.299 5.31-8.003 10.928.297 5.618 4.328 9.994 9.107 10.027l.234 4.424c.394 7.482 8.07 13.62 15.207 16.831l1.281 21.129c.453 7.457 6.636 13.275 14.112 13.275 8.118 0 14.567-6.815 14.117-14.913l-1.24-22.32c6.033-4.066 12.759-10.309 12.41-16.943l-.231-4.396 1.17-.062c4.982-.262 8.774-5.177 8.468-10.979z"
            fill="#AF6D80"
          />
          <path
            id="path174"
            d="M518.701 134.301l-.042-.383.019.009.023.374z"
            fill="#C1C2C4"
          />
          <path
            id="path176"
            d="M519.678 143.352l-.977-9.051-.023-.375-.019-.008-.002-.024a19.434 19.434 0 005.927.601l14.056-.74a19.65 19.65 0 002.461-.303l-21.423 9.9z"
            fill="#8D5C6A"
          />
          <path
            id="path178"
            d="M528.316 123.403a.38.38 0 01.323.194 3.661 3.661 0 003.127 1.885c1.3.025 2.525-.65 3.199-1.763a.377.377 0 11.645.39 4.421 4.421 0 01-3.858 2.128 4.424 4.424 0 01-3.774-2.273.378.378 0 01.148-.513l.19-.048z"
            fill="#322E44"
          />
          <path
            id="path180"
            d="M497.094 101.143a.755.755 0 01-.793-.713c-.244-4.646 3.247-6.061 5.127-6.159a.754.754 0 01.083 1.507c-.404.023-3.924.362-3.703 4.572a.752.752 0 01-.714.793z"
            fill="#322E44"
          />
          <path
            id="path182"
            d="M565.173 97.56a.753.753 0 01-.793-.713c-.227-4.316-3.999-4.168-4.159-4.16a.755.755 0 01-.08-1.507c1.881-.097 5.501.942 5.746 5.587a.754.754 0 01-.714.794z"
            fill="#322E44"
          />
          <path
            id="path184"
            d="M517.801 100.619a1.528 1.528 0 01-1.606-1.446l-.162-3.051a1.528 1.528 0 013.053-.161l.161 3.052a1.528 1.528 0 01-1.446 1.606z"
            fill="#322E44"
          />
          <path
            id="path186"
            d="M540.697 99.414a1.528 1.528 0 01-1.607-1.446l-.161-3.05a1.528 1.528 0 113.052-.161l.162 3.051a1.53 1.53 0 01-1.446 1.606z"
            fill="#322E44"
          />
          <path
            id="path188"
            d="M520.943 89.516c-.69.406-1.656.427-2.587.503-.94.056-1.882.136-2.697.233-.817.098-1.752.242-2.674.408-.923.147-1.867.352-2.639.123-.744-.212-1.153-1.023-.476-2.161.632-1.106 2.509-2.45 5.212-2.78 2.701-.315 4.868.546 5.766 1.468.949.945.762 1.826.095 2.206z"
            fill="#322E44"
          />
          <path
            id="path190"
            d="M545.433 88.303c-.775.273-1.718.121-2.641.028a45.054 45.054 0 00-2.676-.254 46.39 46.39 0 00-2.702-.08c-.931-.022-1.902.01-2.591-.354-.666-.342-.85-1.213.105-2.21.901-.973 3.073-1.956 5.781-1.794 2.702.175 4.578 1.41 5.207 2.477.675 1.1.263 1.933-.483 2.187z"
            fill="#322E44"
          />
          <path
            id="path194"
            d="M533.614 109.863l-3.338.176a5.93 5.93 0 01-6.226-5.6 2.727 2.727 0 012.578-2.862 3.453 3.453 0 003.265-3.626l-.24-4.57a.618.618 0 011.234-.064l.241 4.568a4.69 4.69 0 01-4.434 4.924 1.491 1.491 0 00-1.41 1.565 4.69 4.69 0 004.927 4.431l3.339-.175a.618.618 0 01.064 1.233z"
            fill="#322E44"
          />
          <path
            id="path196"
            d="M499.07 195.81c1.854-6.705 1.162-14.419-1.695-20.426-1.998-4.198-4.913-8.865-3.029-13.44.59-1.433 1.596-2.624 2.409-3.931 4.118-6.618 2.808-13.928 1.075-20.994-.805-3.278-2.419-6.268-3.549-9.474-1.258-3.572-2.298-7.221-3.463-10.825-2.053-6.365-4.583-12.75-9.023-17.677-4.138-4.59-9.751-7.657-15.676-9.306-7.336-2.042-15.248-1.956-22.603.191-7.467 2.18-13.995 7.106-19.986 12.009-6.167 5.05-11.615 11.441-14.395 19.051a34.166 34.166 0 00-1.938 8.796c-.394 4.632.175 9.269-.144 13.901-.642 9.365-6.897 15.167-11.555 22.693-2.789 4.505-4.772 9.915-3.618 15.062 1.582 7.057 8.378 11.4 14.784 14.532 14.479 7.08 30.002 11.911 45.869 14.693 12.584 2.208 28.598 4.992 39.613-3.822 3.448-2.76 5.722-6.684 6.924-11.033z"
            fill="#322E44"
          />
          <path
            id="path198"
            d="M494.705 219.742c-8.065-14.498-17.691-23.412-25.203-28.681a30.568 30.568 0 00-12.377-6.76l-.004-.018c-.175-.044-.209-.052-.118-.017a31.006 31.006 0 00-3.598-.755l-3.552-.521-9.473-1.389-3.552-.52a30.739 30.739 0 00-3.655-.31l.121-.208s-31.108-1.874-60.24 37.763c0 0 124.689 6.88 121.651 1.416z"
            fill="#4E5DB3"
          />
          <path
            id="path200"
            d="M439.817 113.2c-.921 6.467-3.281 13.192-8.869 16.002l-1.776-2.834-.462-.072c-4.364-.682-8.479 2.459-9.191 7.015-.712 4.556 2.248 8.801 6.612 9.482l1.065.166-.15.957c-1.521 9.718 2.774 19.001 10.295 24.326l-3.272 20.93c-.859 5.494 2.901 10.644 8.398 11.503 5.497.858 10.65-2.899 11.508-8.393l3.129-20.003c9.843-2.124 17.84-10.089 19.488-20.627l.161-1.036c3.952.067 7.477-2.914 8.132-7.098.654-4.183-1.793-8.098-5.577-9.237l.822-5.259c-19.928-1.468-33.63-10.343-40.313-15.822z"
            fill="#F9D8D0"
          />
          <path
            id="path202"
            d="M436.035 175.541l1.134-7.422c.058.042.114.083.172.123l-1.135 7.257-.171.042z"
            fill="#AB5F7B"
          />
          <path
            id="path204"
            d="M436.206 175.499l1.135-7.257c-.058-.04-.114-.082-.172-.123l.065-.428a21.051 21.051 0 004.799 1.689l4.856 1.075c1.527.338 3.05.499 4.544.499.703 0 1.399-.036 2.087-.106l.352.318-17.666 4.333z"
            fill="#F49DAC"
          />
          <path
            id="path206"
            d="M469.153 154.258a2.94 2.94 0 01-.426-.032l-5.005-.741a2.89 2.89 0 11.846-5.716l5.005.74a2.888 2.888 0 012.437 3.281 2.892 2.892 0 01-2.857 2.468z"
            fill="#F7C9C7"
          />
          <path
            id="path208"
            d="M442.269 150.308c-.14 0-.284-.01-.427-.032l-5.004-.741a2.888 2.888 0 11.845-5.715l5.005.739a2.892 2.892 0 012.438 3.281 2.892 2.892 0 01-2.857 2.468z"
            fill="#F7C9C7"
          />
          <path
            id="path210"
            d="M453.969 149.864a6.243 6.243 0 01-.589-.058l-1.894-.28a.61.61 0 01-.514-.693.604.604 0 01.693-.512l1.894.28c.954.139 1.892-.008 2.633-.421.689-.384 1.121-.951 1.216-1.597l.134-.906c.027-.177-.095-.332-.167-.408a1.249 1.249 0 00-.708-.338c-1.572-.232-2.695-1.466-2.505-2.75l.656-4.423a.61.61 0 011.205.177l-.655 4.424c-.091.61.586 1.235 1.477 1.368a2.45 2.45 0 011.405.695c.392.405.572.927.498 1.432l-.134.907c-.153 1.028-.803 1.91-1.828 2.482-.818.455-1.8.67-2.817.621z"
            fill="#F17B99"
          />
          <g id="eyes" fill="#322E44">
            <path
              id="path212"
              d="M466.023 145.347a1.515 1.515 0 001.736-1.251l.48-2.987a1.512 1.512 0 00-2.987-.481l-.48 2.986a1.51 1.51 0 001.251 1.733z"
            />
            <motion.path
              id="path214"
              d="M442.805 141.612c.825.134 1.6-.428 1.734-1.252l.481-2.985a1.512 1.512 0 10-2.987-.481l-.482 2.985a1.512 1.512 0 001.254 1.733z"
              initial="hidden"
              animate="visible"
              variants={eyes}
            />
          </g>
          <path
            id="path216"
            d="M463.758 144.56l.267.098c2.335 1.746 4.472.851 4.493.842a.504.504 0 01.402.924c-.109.047-2.699 1.133-5.499-.959a.503.503 0 01.337-.905z"
            fill="#F17B99"
          />
          <path
            id="path218"
            d="M439.99 140.281l.267.099c2.336 1.745 4.472.851 4.494.841a.503.503 0 11.401.924c-.109.048-2.696 1.134-5.498-.957a.504.504 0 01.336-.907z"
            fill="#F17B99"
          />
          <path
            id="path220"
            d="M446.463 155.42a.543.543 0 00-.544.527c-.031 1.064.33 1.932 1.074 2.577 2.173 1.884 6.942 1.092 7.145 1.058a.544.544 0 00-.184-1.07c-.044.006-4.465.739-6.249-.809-.492-.428-.721-.992-.699-1.724a.544.544 0 00-.528-.559h-.015z"
            fill="#F17B99"
          />
          <motion.path
            id="path222"
            d="M449.775 132.339c-.58.117-1.252-.096-1.916-.263a34.96 34.96 0 00-1.924-.474 35.722 35.722 0 00-1.951-.347c-.674-.116-1.381-.197-1.855-.537-.46-.321-.536-.977.222-1.602.719-.615 2.358-1.101 4.311-.691 1.947.418 3.224 1.521 3.609 2.37.415.874.062 1.438-.496 1.544z"
            fill="#322E44"
            initial="hidden"
            animate="visible"
            variants={eyeBrow}
          />
          <path
            id="path224"
            d="M470.982 134.409c-.554.203-1.253.095-1.933.03a34.191 34.191 0 00-1.973-.177 33.505 33.505 0 00-1.983-.049c-.683-.013-1.393.014-1.913-.251-.505-.247-.679-.884-.024-1.618.617-.714 2.165-1.442 4.156-1.333 1.989.118 3.419 1.016 3.927 1.796.544.801.28 1.413-.257 1.602z"
            fill="#322E44"
          />
        </g>
      </g>
      <g id="girl1phone">
        <path
          id="path228"
          d="M110.276 241.092h-.642a1.252 1.252 0 01-1.201-.896h2.004c-.051.298-.106.598-.161.896z"
          fill="#606DBE"
        />
        <path
          id="path230"
          d="M117.645 241.092h-7.369c.055-.298.11-.598.161-.896h8.408a1.251 1.251 0 01-1.2.896z"
          fill="#5F6CBD"
        />
        <path
          id="path232"
          d="M144.559 102.353h-12.642a1.252 1.252 0 011.247-1.355H144.5c.022.461.042.913.059 1.355z"
          fill="#5F6CBD"
        />
        <path
          id="path234"
          d="M151.688 241.092h-18.524a1.251 1.251 0 01-1.2-.896h20.924a1.251 1.251 0 01-1.2.896z"
          fill="#5F6CBD"
        />
        <path
          id="path236"
          d="M176.72 241.092h-18.523a1.252 1.252 0 01-1.201-.896h20.925a1.252 1.252 0 01-1.201.896z"
          fill="#5F6CBD"
        />
        <path
          id="path238"
          d="M353.948 119.615v103.319c0 9.534-7.733 17.262-17.273 17.262H88.606c-9.538 0-17.272-7.728-17.272-17.262V119.615c0-9.534 7.734-17.262 17.272-17.262h248.069c9.54 0 17.273 7.728 17.273 17.262z"
          fill="#3C419F"
        />
        <path
          id="path240"
          d="M204.206 236.149H91.061c-9.315 0-16.866-7.275-16.866-16.248v-97.253c0-8.974 7.551-16.248 16.866-16.248h53.601a85.41 85.41 0 01-.048 3.979h-38.735v121.582h98.329l-.002 4.188zM90.359 158.765c-.553 0-1 .449-1 1.002v23.015a1 1 0 102.001 0v-23.015c0-.553-.448-1.002-1-1.002zm-7.51 11.008a1.502 1.502 0 100 3.003 1.502 1.502 0 000-3.003zm249.922 2.094c-4.458-.028-8.42-.313-11.616-.653v-60.835h-95.201c-.2-1.309-.415-2.636-.646-3.979h107.983c9.315 0 16.866 7.274 16.866 16.248v48.423l-3.323-.017c-1.822.23-3.617.403-5.37.531v-12.703a3.898 3.898 0 00-3.899-3.898h-.895a3.898 3.898 0 00-3.899 3.898v12.985z"
          fill="#4651AC"
        />
        <path
          id="path242"
          d="M105.879 231.961h215.276V110.379H105.879v121.582z"
          fill="#fff"
        />
        <path
          id="path244"
          d="M82.85 172.776a1.502 1.502 0 110-3.003 1.502 1.502 0 010 3.003z"
          fill="#3D43A0"
        />
        <path
          id="path246"
          d="M90.36 183.783a1 1 0 01-1.001-1v-23.016a1 1 0 112.001 0v23.016a1 1 0 01-1 1z"
          fill="#3D43A0"
        />
        <rect y="126" x="108" width="203" height="104" fill="#E5EEF9" />
        <rect y="126" x="108" width="203" height="26" fill="#F4F7FC" />

        <path
          id="path252"
          d="M298.407 133.47h-10.45a1.91 1.91 0 01-1.913-1.91v-7.367c0-1.056.856-1.911 1.913-1.911h10.45c1.056 0 1.912.855 1.912 1.911v1.432l.122-.158 3.869-1.032a.165.165 0 01.208.158v6.565a.164.164 0 01-.165.165.218.218 0 01-.043-.005l-3.869-1.032-.122-.158v1.432a1.91 1.91 0 01-1.912 1.91z"
          fill="#BAC1E7"
        />
      </g>
      <g id="girl1">
        <motion.g
          id="hand"
          initial="hidden"
          animate="visible"
          variants={handMovement}
        >
          <path
            id="path256"
            d="M269.07 135.154l-.301-11.617a2.07 2.07 0 00-2.291-2.049c-1.077.112-1.852 1.102-1.848 2.183l.022 5.327c.004.926-1.082 1.429-1.785.825a3.644 3.644 0 01-1.186-1.968l-2.592-11.548a2.068 2.068 0 00-2.677-1.508c-1.028.341-1.573 1.472-1.336 2.529l2.494 11.112a1.534 1.534 0 01-1.164 1.834 1.349 1.349 0 01-1.551-.821l-4.698-11.85a2.07 2.07 0 00-2.881-1.073c-.962.497-1.322 1.7-.924 2.706l4.829 12.183a1.032 1.032 0 01-.516 1.311l-.289.138a.992.992 0 01-1.211-.291l-6.354-8.304c-.706-.923-2.144-1.27-3.194-.769a2.068 2.068 0 00-.387 2.9l9.164 11.949c.641 1.011 1.275 2.345 1.331 3.714.039.942-1.144 1.409-1.787.719l-3.884-4.163a2.07 2.07 0 00-3.074.057c-.713.814-.607 2.066.133 2.856l4.092 4.369c-.027-.003 5.831 6.134 10.731 8.461l-5.005 52.811a143.714 143.714 0 014.189 7.51l-3.299 1.864-25.048 14.163 23.828 10.966c9.185 3.176 18.761-3.643 18.757-13.355l-.024-77.392s.405-8.707-.264-15.779z"
            fill="#F9D8D0"
          />
          <path
            id="path258"
            d="M248.716 143.115a.514.514 0 01.123-.655 7.73 7.73 0 01.875-.587c.005.064.008.129.012.194.025.62-.48 1.034-1.01 1.048z"
            fill="#EBABC4"
          />
          <path
            id="path260"
            d="M259.132 145.122a.516.516 0 01-.438-.243c-1.114-1.8-2.474-2.85-4.045-3.12a4.93 4.93 0 00-.841-.071c-2.331 0-4.304 1.555-4.325 1.573a.517.517 0 01-.767-.146c.53-.014 1.035-.428 1.01-1.048-.004-.065-.007-.13-.012-.194.893-.526 2.384-1.213 4.081-1.213.334 0 .674.027 1.021.085 1.876.321 3.475 1.53 4.753 3.593a.514.514 0 01-.168.707l-.057.031a.516.516 0 01-.212.046z"
            fill="#F4A2B0"
          />
        </motion.g>
        <path
          id="path262"
          d="M113.264 231.318h28.097l-28.097-15.885v15.885z"
          fill="#F9D8D0"
        />
        <path
          id="path264"
          d="M255.12 214.687c-1.37-2.64-2.77-5.136-4.189-7.51-24.134-40.367-54.267-43.24-54.267-43.24l-18.225-.17-3.909-.036a33.876 33.876 0 00-3.999.207c.104-.022.066-.019-.129-.001l-.006.017a33.298 33.298 0 00-14.454 5.195c-12.349 6.067-30.167 18.893-43.997 45.538l1.319.746 28.097 15.885.23.13 84.006-.069.824-.466.352-.199 25.048-14.162 3.299-1.865z"
          fill="#6C92D3"
        />
        <path
          id="path266"
          d="M163.817 163.823c24.663 0 63.576-3.715 64.739-27.729 0 0-2.503-64.68-23.818-73.007-6.456-2.522-13.25-3.572-19.276-3.321-6.025-.251-12.819.799-19.275 3.32-21.315 8.328-21.702 37.57-21.702 37.57 1.162 24.013-3.295 21.496-12.014 36.794a23.16 23.16 0 00-.585 1.09c-6.5 12.947 3.623 27.748 18.117 27.587 8.058-.089 13.396-2.304 13.814-2.304z"
          fill="#8B8B9A"
        />
        <path
          id="path268"
          d="M210.555 103.957h-.009v-8.684c0-12.478-9.794-22.593-21.877-22.593h-5.497c-12.083 0-21.878 10.115-21.878 22.593v8.684h-.009a7.851 7.851 0 00-7.854 7.85 7.851 7.851 0 007.854 7.849h.009v5.391c0 9.889 6.163 18.273 14.732 21.335v17.078c0 5.461 4.429 9.889 9.894 9.889s9.895-4.428 9.895-9.889v-17.093c8.567-3.06 14.731-11.432 14.731-21.32v-5.391h.009a7.851 7.851 0 007.854-7.849 7.851 7.851 0 00-7.854-7.85z"
          fill="#F9D8D0"
        />
        <path
          id="path270"
          d="M176.085 154.77v-8.364a21.192 21.192 0 007.087 1.234h5.497c2.029 0 3.986-.307 5.85-.841l.328.216-18.762 7.755z"
          fill="#F7BFC0"
        />
        <path
          id="path272"
          d="M204.157 120.702h-4.839a2.765 2.765 0 110-5.527h4.839a2.764 2.764 0 110 5.527z"
          fill="#F7B9BF"
        />
        <path
          id="path274"
          d="M175.124 120.702h-4.838a2.764 2.764 0 110-5.527h4.838a2.764 2.764 0 110 5.527z"
          fill="#F7B9BF"
        />
        <path
          id="path276"
          d="M188.43 135.905a.543.543 0 01-.471-.271 3.27 3.27 0 00-2.823-1.628 3.27 3.27 0 00-2.822 1.628.544.544 0 01-.94-.544 4.362 4.362 0 013.762-2.17 4.36 4.36 0 013.763 2.17.541.541 0 01-.197.741l-.272.074z"
          fill="#F17B99"
        />
        <path
          id="path278"
          d="M198.14 113.27c.797 0 1.442-.646 1.442-1.442v-2.882a1.441 1.441 0 00-2.884 0v2.882c0 .796.646 1.442 1.442 1.442z"
          fill="#322E44"
        />
        <path
          id="path280"
          d="M176.51 113.27c.797 0 1.442-.646 1.442-1.442v-2.882a1.441 1.441 0 00-2.884 0v2.882c0 .796.646 1.442 1.442 1.442z"
          fill="#322E44"
        />
        <path
          id="path282"
          d="M193.911 102.573c.552.426 1.375.557 2.163.728a39.09 39.09 0 012.279.51 39.8 39.8 0 012.245.657c.773.231 1.561.515 2.241.407.654-.098 1.079-.751.608-1.811-.436-1.025-1.914-2.397-4.189-2.991-2.276-.581-4.206-.086-5.059.607-.898.706-.82 1.489-.288 1.893z"
          fill="#8B8B9A"
        />
        <path
          id="path284"
          d="M171.518 105.633c.68.075 1.437-.237 2.183-.497a38.993 38.993 0 012.17-.739c.668-.204 1.44-.412 2.215-.597.766-.202 1.57-.366 2.084-.806.498-.416.52-1.181-.418-1.826-.89-.635-2.829-1.029-5.038-.361-2.204.677-3.565 2.078-3.924 3.094-.389 1.051.075 1.665.728 1.732z"
          fill="#8B8B9A"
        />
        <path
          id="path286"
          d="M179.071 114.622l-.244-.058c-2.454-1.227-4.276-.046-4.294-.034a.545.545 0 01-.753-.151.54.54 0 01.151-.752c.094-.064 2.37-1.539 5.383-.034a.542.542 0 01-.243 1.029z"
          fill="#F17B99"
        />
        <path
          id="path288"
          d="M201.191 114.622l-.244-.058c-2.454-1.227-4.275-.046-4.294-.034a.542.542 0 11-.602-.903c.094-.064 2.37-1.539 5.383-.034a.543.543 0 01-.243 1.029z"
          fill="#F17B99"
        />
        <path
          id="path290"
          d="M187.044 119.18h-2.099a.544.544 0 010-1.086h2.099c2.192 0 3.975-1.56 3.975-3.478v-1.163c0-.553-.535-1.003-1.194-1.003-1.672 0-3.032-1.236-3.032-2.757v-5.674a.542.542 0 111.087 0v5.674c0 .921.873 1.671 1.945 1.671 1.257 0 2.281.937 2.281 2.089v1.163c0 2.517-2.271 4.564-5.062 4.564z"
          fill="#F17B99"
        />
        <path
          id="path292"
          d="M184.07 138.567h4.547c1.42 0 2.573-1.15 2.573-2.57v-5.023c0-.858-.697-1.554-1.556-1.554h-14.717c0 5.052 4.098 9.147 9.153 9.147z"
          fill="#fff"
        />
        <path
          id="path294"
          d="M216.525 111.91a.544.544 0 01-.544-.543c0-4.22-3.723-4.292-3.881-4.293a.544.544 0 01.001-1.086c.05 0 4.967.061 4.967 5.379 0 .3-.242.543-.543.543z"
          fill="#F17B99"
        />
        <path
          id="path296"
          d="M155.418 111.91a.543.543 0 01-.543-.543c0-5.318 4.917-5.379 4.967-5.379a.544.544 0 01.001 1.086c-.158.001-3.882.073-3.882 4.293 0 .3-.243.543-.543.543z"
          fill="#F17B99"
        />
        <path
          id="path298"
          d="M158.387 125.766a1.042 1.042 0 01-1.043-1.041v-8.333a1.042 1.042 0 012.085 0v8.333c0 .575-.466 1.041-1.042 1.041z"
          fill="#322E44"
        />
        <path
          id="path300"
          d="M213.628 125.766a1.043 1.043 0 01-1.044-1.041v-8.333a1.043 1.043 0 012.086 0v8.333c0 .575-.466 1.041-1.042 1.041z"
          fill="#322E44"
        />
        <path
          id="path302"
          d="M179.357 65.965c-18.241 3.03-23.121 25.603-23.121 25.603-2.829 18.775 15.195 15.233 15.195 15.233 5.333.075 9.562-10.082 11.911-17.379 8.182-.48 22.061-2.344 24.442-9.456 3.229-9.645-12.767-16.602-28.427-14.001z"
          fill="#8B8B9A"
        />
        <path
          id="path304"
          d="M165.615 167.158a2.8 2.8 0 003.283 2.213 2.799 2.799 0 10-1.068-5.495 2.8 2.8 0 00-2.215 3.282z"
          fill="#322E44"
        />
        <path
          id="path306"
          d="M168.799 172.528a2.8 2.8 0 003.283 2.213 2.799 2.799 0 10-1.068-5.495 2.8 2.8 0 00-2.215 3.282z"
          fill="#322E44"
        />
        <path
          id="path308"
          d="M173.912 176.81a2.8 2.8 0 105.498-1.07 2.8 2.8 0 00-5.498 1.07z"
          fill="#322E44"
        />
        <path
          id="path310"
          d="M179.807 178.516a2.8 2.8 0 105.499-1.068 2.8 2.8 0 00-5.499 1.068z"
          fill="#322E44"
        />
        <path
          id="path312"
          d="M186.1 177.865a2.8 2.8 0 005.499-1.069 2.801 2.801 0 00-5.499 1.069z"
          fill="#322E44"
        />
        <path
          id="path314"
          d="M192.402 175.785a2.8 2.8 0 005.498-1.067 2.8 2.8 0 00-5.498 1.067z"
          fill="#322E44"
        />
        <path
          id="path316"
          d="M197.476 171.806a2.8 2.8 0 003.284 2.213 2.798 2.798 0 10-1.068-5.495 2.8 2.8 0 00-2.216 3.282z"
          fill="#322E44"
        />
        <path
          id="path318"
          d="M201.349 166.777a2.802 2.802 0 005.499-1.069 2.8 2.8 0 00-3.283-2.213 2.8 2.8 0 00-2.216 3.282z"
          fill="#322E44"
        />
      </g>
      <g id="guy1laptop">
        <path
          id="path320"
          d="M502.723 396.13l-298.596-.148.099-199.95a6.057 6.057 0 016.063-6.053l286.476.141a6.059 6.059 0 016.057 6.061l-.099 199.949z"
          fill="#3C419F"
        />
        <path
          id="path324"
          d="M534.337 432.316l-362.296-.179c-3.931-.001-7.117-2.214-7.116-4.943l.004-7.786c.001-.769.899-1.392 2.008-1.391l372.829.185c1.109 0 2.007.624 2.007 1.393l-.005 7.569c-.001 2.848-3.328 5.155-7.431 5.152z"
          fill="#3C419F"
        />
        <path
          id="path326"
          d="M223.966 380.524l258.933.128a6.634 6.634 0 006.639-6.628l.079-160.923a6.634 6.634 0 00-6.631-6.634l-258.934-.128a6.634 6.634 0 00-6.637 6.627l-.08 160.924a6.633 6.633 0 006.631 6.634z"
          fill="#fff"
        />
        <path
          id="path328"
          d="M489.615 218.133l.002-5.032a6.632 6.632 0 00-6.631-6.633l-258.934-.128a6.632 6.632 0 00-6.637 6.626l-.003 5.05 272.203.117z"
          fill="#F17B99"
        />
        <path
          id="path330"
          d="M465.593 213.091a1.533 1.533 0 11-3.068-.002 1.533 1.533 0 013.068.002z"
          fill="#fff"
        />
        <path
          id="path332"
          d="M471.727 213.095a1.532 1.532 0 11-3.065-.003 1.532 1.532 0 013.065.003z"
          fill="#fff"
        />
        <path
          id="path334"
          d="M477.861 213.098a1.533 1.533 0 01-1.535 1.531 1.533 1.533 0 111.535-1.531z"
          fill="#fff"
        />
        <path
          id="path336"
          d="M464.168 358.147l-223.661-.11.06-120.824 81.652.04-5.524-.003-37.193-.017-.038 78.755 145.79.073.039-78.757-37.192-.018-27.085-.013 103.212.051-.06 120.823z"
          fill="#F4F7FC"
        />
        <path
          id="path338"
          d="M425.254 316.061l-145.79-.073.038-78.755 37.193.018-.02 38.574 71.406.036.02-38.575 37.192.018-.039 78.757z"
          fill="#E5EEF9"
        />
        <path
          id="path340"
          d="M388.101 237.286l-27.085-.013 27.085.013zm-65.882-.032l-5.524-.002v-.001l5.524.003z"
          fill="#E5EEF9"
        />
        <path
          id="path342"
          d="M388.081 275.861l-71.406-.036.02-38.575 5.524.004c1.097.512 2.213.868 3.306 1.054l-2.215 25.06c-.003 6.769 5.485 12.258 12.258 12.262l8.136.004h.005c7.3 0 13.218-5.911 13.222-13.207l-2.19-23.899h.045c2.204 0 4.31-.447 6.23-1.255l27.085.013-.02 38.575z"
          fill="#D8E6F7"
        />
        <path
          id="path344"
          d="M541.774 418.408h-.956a2.706 2.706 0 00-1.052-.206l-372.829-.185h-.004c-.079 0-.156.003-.232.01l6.351-3.726.769.009-6.266 3.707 373.593.017.626.374z"
          fill="#545CB3"
        />
        <path
          id="path346"
          d="M173.821 414.311l-.769-.01 25.423-14.914.564.002-25.218 14.922z"
          fill="#545BB2"
        />
        <path
          id="path348"
          d="M199.039 399.389l-.564-.002 5.804-3.405h.518l-5.758 3.407z"
          fill="#535AB2"
        />
        <path
          id="path350"
          d="M204.797 395.982h-.518l1-.586 26.73.021-26.382.075-.83.49z"
          fill="#3C419F"
        />
        <path
          id="path352"
          d="M540.819 418.408l-374.731-.022.613-.359c.076-.007.153-.01.233-.01h.003l372.829.185c.385 0 .746.076 1.053.206z"
          fill="#3C419F"
        />
        <path
          id="path354"
          d="M541.425 418.034h-.277l-6.247-3.735.261-.006 6.263 3.741z"
          fill="#5360B6"
        />
        <path
          id="path356"
          d="M534.901 414.299l-23.858-14.263h.254l23.865 14.257-.261.006z"
          fill="#525FB5"
        />
        <path
          id="path358"
          d="M511.043 400.036l-7.354-4.396-.965-.001v-.724l8.573 5.121h-.254z"
          fill="#525FB5"
        />
        <path
          id="path360"
          d="M502.724 395.639l-270.715-.222 270.277-.764.438.262v.724z"
          fill="#4C5AB2"
        />
        <path
          id="path362"
          d="M541.148 418.034l-373.593-.017 6.266-3.707c56.392.73 133.262 1.411 207.574 1.412 55.85 0 110.275-.385 153.506-1.423l6.247 3.735z"
          fill="#4F5DB3"
        />
        <path
          id="path364"
          d="M381.395 415.722c-74.312-.001-151.182-.682-207.574-1.412l25.218-14.921c90.579.367 224.568.647 309.945.647h2.059l23.858 14.263c-43.231 1.038-97.656 1.423-153.506 1.423z"
          fill="#4F5DB3"
        />
        <path
          id="path366"
          d="M508.984 400.036c-85.377 0-219.366-.28-309.945-.647l5.758-3.407 297.926.148.001-.491.965.001 7.354 4.396h-2.059z"
          fill="#4F5DB3"
        />
        <path
          id="path368"
          d="M502.723 396.13l-297.926-.148.829-.49 26.383-.075 270.715.222-.001.491z"
          fill="#4C5AB2"
        />
        <path
          id="path370"
          d="M225.146 399.584a5.238 5.238 0 00-3.075.996l-16.578 12.026 297.999.055-15.329-11.014a10.011 10.011 0 00-5.835-1.882l-257.182-.181z"
          fill="#3C419F"
        />
      </g>
      <g id="guy1">
        <path
          id="path372"
          d="M425.85 317.777l12.625 18.289c.216.219-.178-.91 0-1.159l19.807-32.445-.059-.025 1.725-2.705 6.245-10.231c-4.5-4.721-5.614-14.886-5.584-14.866l-2.208-6.954c-.398-1.258.143-2.69 1.354-3.212a2.525 2.525 0 013.413 1.55l2.086 6.619c.344 1.095 1.891 1.202 2.343.146.658-1.537.662-3.335.488-4.785l-3.805-17.953a2.523 2.523 0 011.949-2.987c1.419.001 2.817 1.136 3.111 2.523l2.626 12.468c.118.557.61.956 1.18.956h.392c.66 0 1.209-.513 1.254-1.172l1.087-15.935c.091-1.316 1.121-2.45 2.439-2.492a2.522 2.522 0 012.606 2.691l-1.059 15.501a1.65 1.65 0 001.277 1.718 1.874 1.874 0 002.245-1.408l3.093-13.532c.294-1.286 1.487-2.245 2.797-2.081a2.522 2.522 0 012.155 3.064l-3.216 14.063a4.438 4.438 0 00.269 2.788c.457 1.032 1.917 1.051 2.398.029l2.774-5.871c.563-1.193 1.935-1.875 3.179-1.432a2.52 2.52 0 011.446 3.454l-5.772 12.938c-4.27 11.648-8.894 18.423-10.49 20.57l-5.247 10.999-1.144 2.508-.045-.018-27.117 56.83c-4.235 8.874-15.959 10.93-22.963 4.028l-23.013-26.078 23.359-26.391z"
          fill="#F9D8D0"
        />
        <path
          id="path376"
          d="M394.462 344.035l7.312 2.44 28.162-30.391c-20.501-38.659-45.729-53.241-60.379-58.676-5.723-2.124-11.786-3.161-17.89-3.164l-20.395-.009c-5.519-.003-11.026.884-16.181 2.853-44.562 17.021-60.793 85.659-60.793 85.659l6.045 1.007 29.298 4.886-.016 31.428 104.82.052.017-36.085z"
          fill="#F17B99"
        />
        <path
          id="path378"
          d="M289.208 348.639l-28.629-4.617-.017 36.032 28.631.014.015-31.429z"
          fill="#F9D8D0"
        />
        <path
          id="path384"
          d="M382.428 165.471c-6.124-13.42-16.993-7.996-16.993-7.996-3.13-7.919-12.01-17.298-24.295-18.37-8.946-.779-13.378 2.998-16.33 4.084-6.947-3.89-13.785-4.078-18.772 1.239-7.326 7.81-4.356 14.878-2.423 17.892.545 1.171 3.161 5.201 5.525 6.507-4.017 9.531-7.193 25.153 14.226 26.638l44.806 2.27s3.424-2.891 7.059-7.298c5.353-6.489 11.168-16.269 7.197-24.966z"
          fill="#322E44"
        />
        <path
          id="path386"
          d="M375.231 190.438c-3.635 4.407-7.059 7.297-7.059 7.297l-1.528-17.107c-6.64-.478-8.323-5.161-8.426-9.516l-11.384-.058c-16.275 2.054-30.239-.348-33.369-.957l-.731.057a1.102 1.102 0 01-.356.427l-.008 18.843h-.753c-4.896-.002-8.865 3.961-8.867 8.853v.962c-.004 4.891 3.963 8.859 8.857 8.861l.753.001-.007 12.815c-.005 9.778 6.944 16.331 13.172 17.392l-2.215 25.06c-.003 6.769 5.485 12.259 12.258 12.262l8.136.004c7.301.004 13.223-5.91 13.227-13.207l-2.19-23.898h.037c8.887.004 16.161-7.258 16.165-16.139l.008-14.26h.229c4.894.002 8.865-3.962 8.867-8.853v-.962c.003-3.435-1.957-6.407-4.816-7.877z"
          fill="#F9D8D0"
        />
        <path
          id="path388"
          d="M355.609 249.506l-29.335-11.179a9.47 9.47 0 001.798.189l26.456.013 1.081 10.977z"
          fill="#F7BFC0"
        />
        <path
          id="path392"
          d="M376.642 198.851a.373.373 0 00.373-.373c.002-4.025-3.718-4.074-3.756-4.074a.373.373 0 00-.001.746c.123.001 3.012.056 3.01 3.327 0 .207.167.374.374.374z"
          fill="#F17B99"
        />
        <path
          id="path394"
          d="M305.883 198.816a.372.372 0 01-.372-.374c.002-4.025 3.722-4.07 3.76-4.07a.372.372 0 01.001.746c-.124 0-3.013.053-3.015 3.325a.373.373 0 01-.374.373z"
          fill="#F17B99"
        />
        <path
          id="path396"
          d="M326.231 198.382c-.88 0-1.594-.714-1.593-1.593l.001-3.187a1.595 1.595 0 013.189.001l-.002 3.187a1.593 1.593 0 01-1.595 1.592z"
          fill="#100F0D"
        />
        <path
          id="path398"
          d="M350.682 198.395a1.595 1.595 0 01-1.593-1.594l.001-3.187a1.596 1.596 0 013.19.001l-.002 3.187c0 .879-.715 1.593-1.596 1.593z"
          fill="#100F0D"
        />
        <g id="guy1EyeBrow">
          <motion.path
            id="path400"
            d="M332.157 186.164c-.738.51-1.756.494-2.737.552-.993.031-1.986.095-2.846.189-.863.091-1.85.241-2.827.421-.973.153-1.973.384-2.78.041-.778-.316-1.186-1.417-.442-2.906.696-1.447 2.708-3.154 5.562-3.469 2.852-.299 5.109.95 6.027 2.223.974 1.304.754 2.472.043 2.949z"
            fill="#322E44"
            initial="hidden"
            animate="visible"
            variants={eyeBrowGuy}
          />
          <motion.path
            id="path402"
            d="M358.891 188.799c-.945.269-1.96-.075-2.968-.335a40.285 40.285 0 00-2.928-.734 41.362 41.362 0 00-3.004-.493c-1.037-.163-2.134-.256-2.803-.859-.651-.568-.614-1.8.735-3.047 1.283-1.221 3.992-2.274 6.98-1.666 2.98.625 4.737 2.604 5.142 4.173.447 1.619-.248 2.715-1.154 2.961z"
            fill="#322E44"
            initial="hidden"
            animate="visible"
            variants={eyeBrowGuy}
          />
        </g>
        <path
          id="path404"
          d="M326.072 199.055c.87 0 1.893-.187 3.006-.743a.58.58 0 00-.518-1.038c-2.697 1.349-4.687.087-4.769.033a.582.582 0 00-.803.165.578.578 0 00.16.801c.07.047 1.2.781 2.924.782z"
          fill="#F17B99"
        />
        <path
          id="path406"
          d="M350.523 199.067c.87 0 1.893-.187 3.006-.743a.579.579 0 10-.518-1.037c-2.698 1.348-4.687.086-4.769.031a.584.584 0 00-.803.167.577.577 0 00.16.8c.07.047 1.2.781 2.924.782z"
          fill="#F17B99"
        />
        <path
          id="path408"
          d="M339.992 208.697l6.242.004a.471.471 0 00.001-.942l-6.243-.003a4.262 4.262 0 01-4.256-4.256l.001-1.178c0-.672.547-1.217 1.219-1.217 1.969.001 3.192-1.47 3.193-3.842l.183-6.048a.474.474 0 00-.458-.485c-.243.007-.477.197-.484.457l-.183 6.062c0 .695-.163 2.916-2.251 2.915-1.19 0-2.16.967-2.16 2.156l-.001 1.179a5.204 5.204 0 005.197 5.198z"
          fill="#F17B99"
        />
        <path
          id="path410"
          d="M337.779 231.3l-2.588-.001a2.274 2.274 0 01-2.274-2.273l.004-6.047 14.272-3.559-.001 2.483c-.002 5.192-4.217 9.4-9.413 9.397z"
          fill="#fff"
        />
        <path
          id="path412"
          d="M324.405 187.275c-5.395-.003-9.786 4.381-9.788 9.771-.002 5.391 4.384 9.778 9.778 9.782 5.394.002 9.784-4.381 9.786-9.772.004-5.391-4.382-9.779-9.776-9.781zm-.01 20.639c-5.994-.004-10.868-4.879-10.865-10.868.002-5.989 4.882-10.86 10.875-10.857 5.993.002 10.866 4.879 10.863 10.868-.003 5.989-4.88 10.859-10.873 10.857z"
          fill="#3C419F"
        />
        <path
          id="path414"
          d="M354.768 186.189a9.731 9.731 0 00-6.919 2.861 9.707 9.707 0 00-2.867 6.911 9.714 9.714 0 002.861 6.915 9.721 9.721 0 006.915 2.866 9.723 9.723 0 006.92-2.86 9.71 9.71 0 002.868-6.911 9.711 9.711 0 00-2.862-6.915 9.727 9.727 0 00-6.916-2.867zm-.01 20.639a10.795 10.795 0 01-7.683-3.186 10.778 10.778 0 01-3.18-7.682 10.78 10.78 0 013.187-7.678 10.803 10.803 0 017.687-3.179 10.801 10.801 0 017.683 3.186 10.783 10.783 0 013.181 7.682 10.792 10.792 0 01-3.188 7.679 10.802 10.802 0 01-7.687 3.178z"
          fill="#3C419F"
        />
        <path
          id="path416"
          d="M334.399 195.059a.542.542 0 01-.338-.968c.058-.047 6.03-4.689 10.762.046a.543.543 0 01-.768.768c-4.056-4.055-9.105-.132-9.318.037a.55.55 0 01-.338.117z"
          fill="#3C419F"
        />
      </g>
      <g id="userIcon">
        <path
          id="path418"
          d="M225.116 246.663c0 11.517-9.342 20.853-20.866 20.853s-20.868-9.336-20.868-20.853c0-11.517 9.344-20.853 20.868-20.853s20.866 9.336 20.866 20.853z"
          fill="#fff"
        />
        <path
          id="path420"
          d="M204.25 227.649c-10.491 0-19.027 8.53-19.027 19.015 0 10.483 8.536 19.013 19.027 19.013 10.489 0 19.025-8.53 19.025-19.013 0-10.485-8.536-19.015-19.025-19.015zm0 41.707c-12.521 0-22.708-10.179-22.708-22.692 0-12.514 10.187-22.695 22.708-22.695 12.521 0 22.707 10.181 22.707 22.695 0 12.513-10.186 22.692-22.707 22.692z"
          fill="#F17B99"
        />
        <path
          id="path422"
          d="M211.508 239.356a7.256 7.256 0 01-7.258 7.254 7.256 7.256 0 01-7.259-7.254 7.256 7.256 0 017.259-7.253 7.256 7.256 0 017.258 7.253z"
          fill="#F17B99"
        />
        <path
          id="path424"
          d="M216.497 253.863c0 4.007-5.484 7.254-12.247 7.254-6.765 0-12.248-3.247-12.248-7.254 0-4.006 5.483-7.253 12.248-7.253 6.763 0 12.247 3.247 12.247 7.253z"
          fill="#F17B99"
        />
      </g>
      <g id="plus" fill="#F17B99">
        <path
          id="path426"
          d="M183.197 230.968h-11.253a1.63 1.63 0 110-3.258h11.253a1.63 1.63 0 110 3.258z"
        />
        <path
          id="path428"
          d="M177.571 236.59c-.901 0-1.63-.728-1.63-1.629v-11.245a1.63 1.63 0 013.26 0v11.245c0 .901-.73 1.629-1.63 1.629z"
        />
      </g>
      <g id="userIcon2">
        <path
          id="path430"
          d="M396.48 85.906c0 9.327-7.567 16.889-16.9 16.889-9.333 0-16.899-7.562-16.899-16.89 0-9.326 7.566-16.888 16.899-16.888 9.333 0 16.9 7.562 16.9 16.889z"
          fill="#fff"
        />
        <path
          id="path432"
          d="M379.581 70.506c-8.496 0-15.41 6.91-15.41 15.4s6.914 15.398 15.41 15.398 15.408-6.908 15.408-15.397c0-8.492-6.912-15.4-15.408-15.4zm0 33.779c-10.141 0-18.392-8.244-18.392-18.378 0-10.135 8.251-18.38 18.392-18.38s18.39 8.245 18.39 18.38c0 10.134-8.249 18.378-18.39 18.378z"
          fill="#6C92D3"
        />
        <path
          id="path434"
          d="M385.458 79.988a5.876 5.876 0 01-5.878 5.874 5.876 5.876 0 01-5.878-5.874 5.877 5.877 0 015.878-5.874 5.877 5.877 0 015.878 5.874z"
          fill="#6C92D3"
        />
        <path
          id="path436"
          d="M389.499 91.738c0 3.243-4.441 5.874-9.919 5.874-5.478 0-9.919-2.63-9.919-5.874 0-3.245 4.441-5.876 9.919-5.876 5.478 0 9.919 2.63 9.919 5.876z"
          fill="#6C92D3"
        />
      </g>
      <g id="plus2" fill="#6C92D3">
        <path
          id="path438"
          d="M362.531 73.505h-9.114a1.63 1.63 0 110-3.258h9.114a1.63 1.63 0 110 3.258z"
        />
        <path
          id="path440"
          d="M357.974 78.058c-.9 0-1.63-.728-1.63-1.629v-9.108a1.63 1.63 0 013.26 0v9.108c0 .9-.73 1.63-1.63 1.63z"
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
